import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=56b73489"
import script from "./Denied.vue?vue&type=script&lang=js"
export * from "./Denied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports